// import styles from "../AddCandidatesComp.module.css";
// import style from "../../../Screens/Settings/Application/Application.module.css";
import commonCssStyle from "../../UI/CommonCss.module.css";
import { useEffect, useState } from "react";
import {
  Table,
  Row,
  Col,
  Button,
  Modal,
  Form,
  Menu,
  Dropdown,
  Select,
  Input,
  Checkbox,
  message,
} from "antd";
import { getRecruitmentsAllCandidatesFilterAction } from "../../../Reusable/Store/Action/RecruitmentAction";
import {
  ThreeDotsIcon,
  Filedownload,
  CalendarCheckIcon,
  FilterOutlinedIcon,
  NotifyClientIcon,
  TrashIcon,
  LinkBreak,
  SearchIcon,
  BrieftCaseIcon,
} from "../../IconsComp/Icons";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { connect } from "react-redux";
import Steps from "../../UI/Steps";
import { Option } from "antd/lib/mentions";
import RecruitmentCandidateFilter from "./RecruitmentCandidateFilter";
import ScheduleInterviewDrawer from "../AddCandidatesComp/CandidatesSummary/ScheduleInterviewDrawer";
import {
  getRecruitmentsFilterAction,
  getRecruitmentAllStatusAction,
  deleteCandidatesFroPoolAction,
  exportRecruitmentDetaisAction,
  shareRecruitmentCandidatesResumesToClientAction,
} from "../../../Reusable/Store/Action/RecruitmentAction";
import { getClientsAction } from "../../../Reusable/Store/Action/ClientAction";
import { getRequirementsAction } from "../../../Reusable/Store/Action/RequirementAction";
import { getEmployeesAction } from "../../../Reusable/Store/Action/EmployeesAction";
import { getTagsAction } from "../../../Reusable/Store/Action/Master/MasterTagsAction";
import { getCandidatesAction } from "../../../Reusable/Store/Action/CandidatesAction";
import styles from "../../Screens/ClientCompany/ClientCompany.module.css";
import PermissionMessage from "../../UI/PermissionMessage";
import { checkPermissionAction } from "../../../Reusable/Store/Action/AuthPermissionsAction";
import BreadcrumbForRecruitment from "./BreadcrumbForRecruitment";
import moment from "moment";
import ColumnSelectorModal from "./ColumnSelectorModal";
import { downloadCandidatesExcel } from "./ExcelExportUtility";

function RecruitmentCandidates(props) {
  const MAX_SHARE_WITH_CLIENT_SELECTION = 10;
  const location = useLocation();
  const fetchRecords = (page) => {
    let recuritmentCandidateFilterLocal = JSON.parse(
      localStorage.getItem("recuritmentCandidateFilter")
    );

    if (recuritmentCandidateFilterLocal) {
      const val = {
        ...props.candidatesFilterData,
        ...recuritmentCandidateFilterLocal,
        current_page: page,
        id: props.idData,
      };
      localStorage.setItem(
        "candidateListForPool",
        JSON.stringify({
          ...recuritmentCandidateFilterLocal,
          current_page: page,
        })
      );
      props.getCandidatesFilterAllDataHandler(val);
    } else {
      const val = {
        ...props.candidatesFilterData,
        current_page: page,
        id: props.idData,
      };
      localStorage.setItem(
        "candidateListForPool",
        JSON.stringify({
          current_page: page,
        })
      );

      props.getCandidatesFilterAllDataHandler(val);
    }

    // console.log(val);
  };

  const dataFormate =
    props.settindsData && props.settindsData.dateFormat
      ? props.settindsData.dateFormat
      : "DD/MM/YYYY";

  useEffect(() => {
    let unsubscribed = false;
    if (!unsubscribed) {
      let recuritmentCandidateFilter = localStorage.getItem(
        "recuritmentCandidateFilter"
      );

      if (recuritmentCandidateFilter) {
        let recuritmentCandidateFilter1 = JSON.parse(
          recuritmentCandidateFilter
        );
        props.getCandidatesFilterAllDataHandler({
          id: props.idData,
          current_page: 1,
          ...recuritmentCandidateFilter1,
        });
      } else {
        props.getCandidatesFilterAllDataHandler({
          id: props.idData,
          current_page: 1,
        });
      }

      props.getClientsHandler();
      props.getTagHandler();
      props.getRequirementAction();
      props.getEmployeesAction();
      props.getCandidateDetailsHandler({});
      props.getTagHandler();
      props.getRecruitmentAllStatusHandler();
    }
    return () => {
      unsubscribed = true;
    };
  }, []);
  const navigate = useNavigate();
  const [open, setOpen] = useState(false);
  const [openFilter, setOpenFilter] = useState(false);
  const [deletId, setDeleteId] = useState("");
  const [openDeleteModal, SetOpenDeleteModal] = useState(false);
  const [openJobModal, SetOpenJobModal] = useState(false);
  const [hoverKey, setHoverKey] = useState("0");
  const [openPMModal, setOpenPMModal] = useState({
    open: false,
    permission: "",
  });
  const [opeRecruitmentCandidateFilter, setOpenRecruitmentCandidateFilter] =
    useState(false);
  const [interviewName, setInterviewName] = useState("");
  const [editIconHover, setEditIconHver] = useState(false);
  const [scheduleDrawer, setScheduleDrawer] = useState(false);
  const [candidateId, setCandidateId] = useState({});
  const [selectedRowKeys, setSelectedRowKeys] = useState([]);
  const [cfilter, setCFilter] = useState({});
  const [columnSelectorOpen, setColumnSelectorOpen] = useState(false);
  const [exportLoading, setExportLoading] = useState(false);
  const [shareModalOpen, setShareModalOpen] = useState(false);
  const [shareSubmitting, setShareSubmitting] = useState(false);
  const [shareFormValid, setShareFormValid] = useState(false);
  const [shareForm] = Form.useForm();

  // function confirmDeleteHandler() {
  //   SetOpenDeleteModal(false);

  //   setDeleteId("");
  // }
  function closeDrawerHandler() {
    setScheduleDrawer(false);
  }

  const recruitmentFilterHandler = (val) => {
    if (val.applyfilter === "clear selected") {
      setSelectedRowKeys([]);
    }

    const data = {
      id: props.idData,
      ...val,
      current_page: 1,
    };
    setCFilter(val);
    props.getCandidatesFilterAllDataHandler(data);
  };

  // Available columns for export (based on recruitment candidate filter API response)
  const availableColumnsForExport = [
    { key: "name", label: "Name" },
    { key: "mobileNumber", label: "Mobile Number" },
    { key: "emailId", label: "Email ID" },
    { key: "role", label: "Role" },
    { key: "currentCompany", label: "Current Company" },
    { key: "totalExperienceMonths", label: "Total Experience (Months)" },
    { key: "location", label: "Location" },
    { key: "currentCTC", label: "Current CTC" },
    { key: "expectedCTC", label: "Expected CTC" },
    { key: "noticePeriod", label: "Notice Period" },
    { key: "highestQualification", label: "Highest Qualification" },
  ];

  // Handle export button click - open column selector
  const handleExportClick = () => {
    if (!props.import_candidates_Filter_Data || !props.import_candidates_Filter_Data.data || props.import_candidates_Filter_Data.data.length === 0) {
      message.warning("No candidates to export", 3);
      return;
    }
    setColumnSelectorOpen(true);
  };

  // Handle export with selected columns
  const handleExportWithColumns = (selectedColumns) => {
    setExportLoading(true);
    try {
      const pageData = props.import_candidates_Filter_Data.data || [];

      // If user selected candidates, export only selected (from current page); otherwise export all on page
      const selectedSet = new Set((selectedRowKeys || []).map((x) => String(x)));
      const dataToExport =
        selectedSet.size > 0
          ? pageData.filter((row) => selectedSet.has(String(row?.id)))
          : pageData;

      if (!dataToExport || dataToExport.length === 0) {
        message.warning(
          selectedSet.size > 0
            ? "Selected candidates are not available on this page to export"
            : "No candidates to export",
          3
        );
        setExportLoading(false);
        return;
      }
       
      // Download excel with selected columns
      const success = downloadCandidatesExcel(
        dataToExport,
        selectedColumns,
        availableColumnsForExport,
        "Recruitment_Candidates_Pool"
      );

      if (success) {
        message.success(
          selectedRowKeys && selectedRowKeys.length > 0
            ? "Selected candidates exported successfully"
            : "Candidates exported successfully",
          3
        );
      } else {
        message.error("Failed to export candidates", 3);
      }
    } catch (error) {
      console.error("Export error:", error);
      message.error("Error while exporting candidates", 3);
    } finally {
      setExportLoading(false);
    }
  };



  const data = [
    {
      key: "1",
      jobcode: "DEV23",
      jobtitle: "UX Designer1",
      companyname: "Devusoft",
      positionclosed: "3/10",
      shortlisted: "6",
      interviewed: "6",
      number: "one",
      offered: "6",
    },
    {
      key: "3",
      jobcode: "ENG12",
      jobtitle: "Graphic Designer",
      companyname: "Engima",
      positionclosed: "3/10",
      shortlisted: "6",
      interviewed: "6",
      number: "two",
      offered: "6",
    },
    {
      key: "4",
      jobcode: "ENG12",
      jobtitle: "Graphic Designer",
      companyname: "Engima",
      positionclosed: "3/10",
      shortlisted: "6",
      interviewed: "6",
      number: "three",
      offered: "6",
    },
    {
      key: "5",
      jobcode: "ENG12",
      jobtitle: "Graphic Designer",
      companyname: "Engima",
      positionclosed: "3/10",
      shortlisted: "6",
      interviewed: "6",
      number: "one",
      offered: "6",
    },
  ];

  function confirmDeleteHandler() {
    props.deleteCandidateFromPool(
      { filterId: props.idData, id: deletId },
      (success) => {
        if (success) {
          SetOpenDeleteModal(false);
        }
      }
    );
    setDeleteId("");
  }

  const handleProvinceChange = (e) => {
    let recuritmentCandidateFilterLocal = JSON.parse(
      localStorage.getItem("recuritmentCandidateFilter")
    );
    localStorage.setItem("recuritmentCandidateSort", e);
    if (recuritmentCandidateFilterLocal) {
      localStorage.setItem(
        "recuritmentCandidateFilter",
        JSON.stringify({
          ...recuritmentCandidateFilterLocal,
          id: props.idData,
          sortBy: "name",
          current_page: 1,
          sortOrder: "ASC",
        })
      );
      if (e === "Name_ASC") {
        props.getCandidatesFilterAllDataHandler({
          // ...cfilter,
          ...recuritmentCandidateFilterLocal,
          id: props.idData,
          sortBy: "name",
          current_page: 1,
          sortOrder: "ASC",
        });
      } else if (e === "Name_DESC") {
        localStorage.setItem(
          "recuritmentCandidateFilter",
          JSON.stringify({
            ...recuritmentCandidateFilterLocal,
            id: props.idData,
            sortBy: "name",
            current_page: 1,
            sortOrder: "DESC",
          })
        );
        props.getCandidatesFilterAllDataHandler({
          // ...cfilter,
          ...recuritmentCandidateFilterLocal,
          id: props.idData,
          sortBy: "name",
          current_page: 1,
          sortOrder: "DESC",
        });
      } else if (e === "Applied_ASC") {
        localStorage.setItem(
          "recuritmentCandidateFilter",
          JSON.stringify({
            ...recuritmentCandidateFilterLocal,
            id: props.idData,
            sortBy: "appliedDate",
            current_page: 1,
            sortOrder: "ASC",
          })
        );
        props.getCandidatesFilterAllDataHandler({
          // ...cfilter,
          ...recuritmentCandidateFilterLocal,
          id: props.idData,
          sortBy: "appliedDate",
          current_page: 1,
          sortOrder: "ASC",
        });
      } else if (e === "Applied_DESC") {
        localStorage.setItem(
          "recuritmentCandidateFilter",
          JSON.stringify({
            ...recuritmentCandidateFilterLocal,
            id: props.idData,
            sortBy: "appliedDate",
            current_page: 1,
            sortOrder: "DESC",
          })
        );
        props.getCandidatesFilterAllDataHandler({
          // ...cfilter,
          ...recuritmentCandidateFilterLocal,
          id: props.idData,
          sortBy: "appliedDate",
          current_page: 1,
          sortOrder: "DESC",
        });
      } else if (e === "Last_ASC") {
        localStorage.setItem(
          "recuritmentCandidateFilter",
          JSON.stringify({
            ...recuritmentCandidateFilterLocal,
            id: props.idData,
            sortBy: "lastUpdated",
            current_page: 1,
            sortOrder: "ASC",
          })
        );
        props.getCandidatesFilterAllDataHandler({
          // ...cfilter,
          ...recuritmentCandidateFilterLocal,
          id: props.idData,
          sortBy: "lastUpdated",
          current_page: 1,
          sortOrder: "ASC",
        });
      } else if (e === "Last_DESC") {
        localStorage.setItem(
          "recuritmentCandidateFilter",
          JSON.stringify({
            ...recuritmentCandidateFilterLocal,
            id: props.idData,
            sortBy: "lastUpdated",
            current_page: 1,
            sortOrder: "DESC",
          })
        );
        props.getCandidatesFilterAllDataHandler({
          // ...cfilter,
          ...recuritmentCandidateFilterLocal,
          id: props.idData,
          sortBy: "lastUpdated",
          current_page: 1,
          sortOrder: "DESC",
        });
      }
    } else {
      if (e === "Name_ASC") {
        localStorage.setItem(
          "recuritmentCandidateFilter",
          JSON.stringify({
            id: props.idData,
            sortBy: "name",
            current_page: 1,
            sortOrder: "ASC",
          })
        );
        props.getCandidatesFilterAllDataHandler({
          // ...cfilter,
          id: props.idData,
          sortBy: "name",
          current_page: 1,
          sortOrder: "ASC",
        });
      } else if (e === "Name_DESC") {
        localStorage.setItem(
          "recuritmentCandidateFilter",
          JSON.stringify({
            id: props.idData,
            sortBy: "name",
            current_page: 1,
            sortOrder: "DESC",
          })
        );
        props.getCandidatesFilterAllDataHandler({
          // ...cfilter,
          id: props.idData,
          sortBy: "name",
          current_page: 1,
          sortOrder: "DESC",
        });
      } else if (e === "Applied_ASC") {
        localStorage.setItem(
          "recuritmentCandidateFilter",
          JSON.stringify({
            id: props.idData,
            sortBy: "appliedDate",
            current_page: 1,
            sortOrder: "ASC",
          })
        );
        props.getCandidatesFilterAllDataHandler({
          // ...cfilter,
          id: props.idData,
          sortBy: "appliedDate",
          current_page: 1,
          sortOrder: "ASC",
        });
      } else if (e === "Applied_DESC") {
        localStorage.setItem(
          "recuritmentCandidateFilter",
          JSON.stringify({
            id: props.idData,
            sortBy: "appliedDate",
            current_page: 1,
            sortOrder: "DESC",
          })
        );
        props.getCandidatesFilterAllDataHandler({
          // ...cfilter,
          id: props.idData,
          sortBy: "appliedDate",
          current_page: 1,
          sortOrder: "DESC",
        });
      } else if (e === "Last_ASC") {
        localStorage.setItem(
          "recuritmentCandidateFilter",
          JSON.stringify({
            id: props.idData,
            sortBy: "lastUpdated",
            current_page: 1,
            sortOrder: "ASC",
          })
        );
        props.getCandidatesFilterAllDataHandler({
          // ...cfilter,
          id: props.idData,
          sortBy: "lastUpdated",
          current_page: 1,
          sortOrder: "ASC",
        });
      } else if (e === "Last_DESC") {
        localStorage.setItem(
          "recuritmentCandidateFilter",
          JSON.stringify({
            id: props.idData,
            sortBy: "lastUpdated",
            current_page: 1,
            sortOrder: "DESC",
          })
        );
        props.getCandidatesFilterAllDataHandler({
          // ...cfilter,
          id: props.idData,
          sortBy: "lastUpdated",
          current_page: 1,
          sortOrder: "DESC",
        });
      }
    }
  };

  function closeDeleteHandler() {
    SetOpenDeleteModal(false);
  }

  const showDrawer = () => {
    setOpen(true);
  };
  const closeHandler = () => {
    setOpen(false);
  };

  function showFilterHandler() {
    setOpenFilter(true);
  }

  function OpenRecruitmentCanidateFilter() {
    setOpenRecruitmentCandidateFilter(true);
  }

  function CloseFilterHandler() {
    setOpenRecruitmentCandidateFilter(false);
  }

  const closeFilterHandler = () => {
    setOpenFilter(false);
  };
  const editJob = () => {
    SetOpenJobModal(true);
  };

  const openShareModal = () => {
    if (!selectedRowKeys || selectedRowKeys.length === 0) {
      message.warning("Select at least 1 candidate to share", 3);
      return;
    }
    shareForm.resetFields();
    setShareFormValid(false);
    setShareModalOpen(true);
  };

  const closeShareModal = () => {
    setShareModalOpen(false);
    setShareSubmitting(false);
    shareForm.resetFields();
    setShareFormValid(false);
  };

  const submitShareToClient = async () => {
    try {
      const values = await shareForm.validateFields();
      const clientId = values?.clientId?.trim();
      if (!clientId) return;

      const pageData =
        (props.import_candidates_Filter_Data &&
          props.import_candidates_Filter_Data.data) ||
        [];
      const selectedSet = new Set((selectedRowKeys || []).map((x) => String(x)));
      const selectedRows = pageData.filter((row) =>
        selectedSet.has(String(row?.id))
      );
      const rowsWithResume = selectedRows.filter(
        (row) => row && row.resume && String(row.resume).trim().length > 0
      );
      const candidateIds = rowsWithResume.map((row) => row.id);

      if (candidateIds.length === 0) {
        message.warning(
          "Selected candidates do not have resumes. Nothing to share.",
          3
        );
        return;
      }

      if (candidateIds.length !== selectedRows.length) {
        message.info(
          `${selectedRows.length - candidateIds.length} selected candidate(s) without resumes were excluded.`,
          3
        );
      }

      const rawMessage = values?.message?.trim() || "";
      const content = rawMessage ? `<p>${rawMessage}</p>` : "";

      setShareSubmitting(true);
      props.shareRecruitmentCandidatesResumesToClient(
        { clientId, candidateIds, content },
        (success) => {
          setShareSubmitting(false);
          if (success) {
            message.success("Resumes shared with client", 3);
            closeShareModal();
            setSelectedRowKeys([]);
          }
        }
      );
    } catch (e) {
      // AntD validation error - no-op
    }
  };


  const columns = [
    {
      dataIndex: "id",
      render: (text, render) => (
        <>
          <Checkbox
            checked={selectedRowKeys.find((x) => x === text)}
            onChange={(val) => {
              if (val.target.checked) {
                if (selectedRowKeys.includes(text)) return;
                if (selectedRowKeys.length >= MAX_SHARE_WITH_CLIENT_SELECTION) {
                  message.warning(
                    `You can select up to ${MAX_SHARE_WITH_CLIENT_SELECTION} candidates`,
                    3
                  );
                  return;
                }
                setSelectedRowKeys([...selectedRowKeys, text]);
              } else {
                let index = selectedRowKeys.indexOf(text);
                if (index != -1) {
                  setSelectedRowKeys(
                    selectedRowKeys.filter((data) => data !== text)
                  );
                }
              }
            }}
          />
        </>
      ),
    },
    {
      title: (
        <p style={{ textAlign: "center" }} className={styles.LabelName}>
          Name
        </p>
      ),
      dataIndex: "candidateName",
      render: (text, render) =>
        props.permissions &&
        props.permissions.find(
          (data) => data === "recruitment-candidate-detail"
        ) ? (
          // <p
          //   state={{
          //     id: render.candidateId,
          //     from: "recruitmentList",
          //     backIconid: render.id,
          //     jobDetailsPageId: location.state,
          //   }}
          //   to={"/candidatesDetailsPage/summary"}
          // >
          <p
            onClick={() => {
              props.getCheckPermissionHandler(
                "recruitment-candidate-detail",
                (success) => {
                  if (success) {
                    navigate("/candidatesDetailsPage/summary", {
                      state: {
                        id: render.candidateId,
                        from: "recruitmentList",
                        backIconid: render.id,
                        jobDetailsPageId: location.state,
                        recuritmentJobDetailsName:
                          location.state.recuritmentJobDetailsName,
                      },
                    });
                  } else {
                    setOpenPMModal({
                      open: true,
                      permission: "Recruitment Candidate Details",
                    });
                  }
                }
              );
            }}
            style={{
              color: "var(--primaryColor)",
              fontFamily: "Helvetica,ProductSans",
              fontStyle: "normal",
              fontWeight: "700",
              fontSize: "14px",
              lineHeight: "17px",
              margin: "0px",
              cursor: "pointer",
            }}
          >
            {text ? text : "NA"}
          </p>
        ) : (
          // </p>
          <p
            className={commonCssStyle.marginBottomRemove}
            style={{ textAlign: "center", color: "#2F7BF5" }}
          >
            {text ? text : "NA"}
          </p>
        ),
    },
    {
      title: (
        <p style={{ textAlign: "center" }} className={styles.LabelName}>
          Reporting Manager
        </p>
      ),
      dataIndex: "teamMember",
      render: (text, data) => {
        return (
          <p
            style={{ textAlign: "center" }}
            className={`${commonCssStyle.tableData} ${commonCssStyle.marginBottomRemove}`}
          >
            {text ? text : "NA"}
          </p>
        );
      },
    },
    {
      title: (
        <p style={{ textAlign: "center" }} className={styles.LabelName}>
          Resume Link
        </p>
      ),
      dataIndex: "resume",
      render: (text, render) => (
        <>
          <Row style={{ justifyContent: "center" }}>
            {text && (
              <span
                className={commonCssStyle.coursorPointer}
                onClick={() => {
                  window.open(render.resume, "_blank");
                }}
              >
                <Filedownload color={"var(--primaryColor)"} />
              </span>
            )}
          </Row>
        </>
      ),
    },
    {
      title: (
        <p style={{ textAlign: "center" }} className={styles.LabelName}>
          Email and Number
        </p>
      ),
      dataIndex: "candidatePhone",
      render: (text, data) => {
        return (
          <>
            <p
              style={{ textAlign: "center" }}
              className={`${commonCssStyle.tableData}`}
            >
              {data.email}
            </p>
            <p
              style={{ textAlign: "center" }}
              className={`${commonCssStyle.tableData} ${commonCssStyle.marginBottomRemove}`}
            >
              {data.candidatePhone}
            </p>
          </>
        );
      },
    },
    {
      title: (
        <p style={{ textAlign: "center" }} className={styles.LabelName}>
          Applied Date
        </p>
      ),
      dataIndex: "appliedDate",
      render: (text) => {
        return (
          <p
            style={{ textAlign: "center" }}
            className={`${commonCssStyle.tableData} ${commonCssStyle.marginBottomRemove}`}
          >
            {text ? moment(text).format(dataFormate) : "NA"}
          </p>
        );
      },
    },
    {
      title: (
        <p style={{ textAlign: "center" }} className={styles.LabelName}>
          Last Updated
        </p>
      ),
      dataIndex: "lastUpdatedDate",
      render: (text) => {
        return (
          <p
            style={{ textAlign: "center" }}
            className={`${commonCssStyle.tableData} ${commonCssStyle.marginBottomRemove}`}
          >
            {text ? moment(text).format(dataFormate) : "NA"}
          </p>
        );
      },
    },
    {
      title: (
        <p style={{ textAlign: "center" }} className={styles.LabelName}>
          Active Applied Job Count
        </p>
      ),
      dataIndex: "activeJobCount",
      render: (text) => {
        return (
          <p
            style={{ textAlign: "center" }}
            className={`${commonCssStyle.tableData} ${commonCssStyle.marginBottomRemove}`}
          >
            {text && text}
          </p>
        );
      },
    },
    {
      title: (
        <p style={{ textAlign: "center" }} className={styles.LabelName}>
          Offer Count
        </p>
      ),
      dataIndex: "offerJobCount",
      render: (text) => (
        <p
          style={{ textAlign: "center" }}
          className={`${commonCssStyle.tableData} ${commonCssStyle.marginBottomRemove}`}
        >
          {text && text}
        </p>
      ),
    },
    {
      title: (
        <p style={{ textAlign: "center" }} className={styles.LabelName}>
          Offer Declined
        </p>
      ),
      dataIndex: "offerDeclinedJobCount",
      render: (text) => (
        <p
          style={{ textAlign: "center" }}
          className={`${commonCssStyle.tableData} ${commonCssStyle.marginBottomRemove}`}
        >
          {text && text}
        </p>
      ),
    },

    {
      title: <p className={styles.LabelName}>Current Stage</p>,
      dataIndex: "currentStageNumber",
      render: (text, render) => {
        return (
          <>
            {/* <Steps number={text} /> */}
            <Row>
              <Col>
                <Row>
                  <Col>
                    <p className={`${commonCssStyle.tableData}`}>
                      {render.currentStageType}
                    </p>
                  </Col>
                </Row>
                <Row>
                  <Col>
                    <p className={`${commonCssStyle.tableData}`}>
                      {render.currentStage}
                    </p>
                  </Col>
                </Row>
              </Col>
            </Row>
          </>
        );
      },
    },
    {
      title: "",
      dataIndex: "",

      render: (text, render) => {
        return (
          <>
            <Dropdown
              overlay={
                <Menu
                  style={{ /*  paddingBottom: "10px", */ width: "220px" }}
                  items={[
                    props.permissions &&
                      props.permissions.find(
                        (data) => data === "interview-add"
                      ) && {
                        key: "1",
                        label: (
                          <>
                            <Row
                              align="middle"
                              onClick={() => {
                                setCandidateId({
                                  id: render.candidateId,
                                  name: render.name,
                                  jobId: render.jobId,
                                });
                                setInterviewName("recruitment");
                                setScheduleDrawer(true);
                              }}
                              onMouseEnter={() => {
                                setHoverKey("1");
                              }}
                              onMouseLeave={() => {
                                setHoverKey("0");
                              }}
                            >
                              <Col
                                style={{
                                  padding: "5px 5px 0px 0px",
                                  transform: "translateY(3px)",
                                }}
                              >
                                <CalendarCheckIcon
                                  color={
                                    hoverKey === "1"
                                      ? "var(--primaryColor) "
                                      : "var(--body-text-color)"
                                  }
                                />
                              </Col>
                              <Col style={{ padding: "5px 5px 0px 5px" }}>
                                <p
                                  style={{
                                    margin: "0px",
                                    color:
                                      hoverKey === "1"
                                        ? "var(--primaryColor) "
                                        : "var(--body-text-color)",
                                  }}
                                >
                                  Schedule Interview
                                </p>
                              </Col>
                            </Row>
                          </>
                        ),
                      },
                    props.permissions &&
                      props.permissions.find(
                        (data) => data === "recruitment-delete-candidate"
                      ) && {
                        key: "2",
                        label: (
                          <>
                            <Row
                              align="middle"
                              onMouseEnter={() => {
                                setHoverKey("2");
                              }}
                              onMouseLeave={() => {
                                setHoverKey("0");
                              }}
                              onClick={() => {
                                SetOpenDeleteModal(true);
                                setDeleteId(render.id);
                              }}
                            >
                              <Col
                                style={{
                                  padding: "5px 5px 0px 0px",
                                  transform: "translateY(3px)",
                                }}
                              >
                                {/* <TrashIcon
                                color={
                                  hoverKey === "2"
                                    ? "#F83A3A"
                                    : "var(--body-text-color)"
                                }
                              /> */}
                                <LinkBreak
                                  color={
                                    hoverKey === "2"
                                      ? "#F83A3A"
                                      : "var(--body-text-color)"
                                  }
                                />
                              </Col>
                              <Col style={{ padding: "5px 5px 0px 5px" }}>
                                <p
                                  style={{
                                    margin: "0px",
                                    color:
                                      hoverKey === "2"
                                        ? "#F83A3A"
                                        : "var(--body-text-color)",
                                  }}
                                >
                                  Unlink
                                </p>
                              </Col>
                            </Row>
                          </>
                        ),
                      },
                    // props.permissions &&
                    //   props.permissions.find(
                    //     (data) => data === "job-detail"
                    //   ) && {
                    //     key: "3",
                    //     label: (
                    //       <Row
                    //         style={{ gap: "10px" }}
                    //         align="middle"
                    //         onMouseEnter={() => {
                    //           setHoverKey("3");
                    //         }}
                    //         onMouseLeave={() => {
                    //           setHoverKey("0");
                    //         }}
                    //         onClick={() => {
                    //           props.getCheckPermissionHandler(
                    //             "job-detail",
                    //             (success) => {
                    //               if (success) {
                    //                 navigate("/JobDetailPage", {
                    //                   state: {
                    //                     id: render.jobId,
                    //                     activeTabKey: "1",
                    //                   },
                    //                 });
                    //               } else {
                    //                 setOpenPMModal({
                    //                   open: true,
                    //                   permission: "Job Details",
                    //                 });
                    //               }
                    //             }
                    //           );
                    //         }}
                    //       >
                    //         <Col>
                    //           <BrieftCaseIcon
                    //             color={
                    //               hoverKey === "3"
                    //                 ? "var(--primaryColor) "
                    //                 : "var(--body-text-color)"
                    //             }
                    //           />
                    //         </Col>
                    //         <Col>
                    //           <p
                    //             style={{
                    //               margin: "0px",
                    //               color:
                    //                 hoverKey === "3"
                    //                   ? "var(--primaryColor) "
                    //                   : "var(--body-text-color)",
                    //             }}
                    //           >
                    //             Job Detail
                    //           </p>
                    //         </Col>
                    //       </Row>
                    //     ),
                    //   },
                  ]}
                />
              }
            >
              <span
                className={commonCssStyle.coursorPointer}
                onClick={(e) => e.preventDefault()}
              >
                <ThreeDotsIcon color={"var(--icons-color)"} />
              </span>
            </Dropdown>
          </>
        );
      },
    },
  ];

  return (
    <>
      <Row>
        <Col md={24}>
          {/* {open&&  <RequirementDrawer onOpen={open} onClose={closeHandler} />} */}
          <Row justify="end" align="middle" style={{ marginBottom: "20px" }}>
            <Col>
              <div
                style={{
                  display: "flex",
                  gap: "16px",
                  flexWrap: "wrap",
                  justifyContent: "flex-end",
                  alignItems: "center",
                }}
              >
                <Button
                  onClick={OpenRecruitmentCanidateFilter}
                  className={`${commonCssStyle.filterButton}`}
                >
                  <Row style={{ gap: "11px" }}>
                    <Col>
                      <span style={{ transform: "translateY(2px)" }}>
                        <FilterOutlinedIcon color={"var(--primaryColor)"} />
                      </span>
                    </Col>
                    <Col>
                      <p
                        className={`${commonCssStyle.filterAndSortTextStyle} ${commonCssStyle.marginBottomRemove}`}
                      >
                        Filter
                      </p>
                    </Col>
                  </Row>
                </Button>

                <Button
                  style={{ height: "40px" }}
                  className={` ${commonCssStyle.sortBtn}`}
                >
                  <Row justify="space-between">
                    <Col>
                      <p style={{ transform: "translateY(2px)" }}>Sort By</p>
                    </Col>
                    <Col>
                      <Select
                        style={{ width: "100%", transform: "translateY(3px)" }}
                        onChange={handleProvinceChange}
                        bordered={false}
                        placeholder={
                          <p
                            style={{
                              margin: "0px",
                              color: "var(--primaryColor)",
                            }}
                          >
                            Select
                          </p>
                        }
                        value={
                          localStorage.getItem("recuritmentCandidateSort")
                            ? localStorage.getItem("recuritmentCandidateSort")
                            : "Select"
                        }
                        size="small"
                        className={`${commonCssStyle.filterDrop}  selectInput sortBySelectStyle selectTag selectTag1`}
                      >
                        <Select.Option key="1" value="Name_ASC">
                          Name Ascending
                        </Select.Option>
                        <Select.Option key="2" value="Name_DESC">
                          Name Descending
                        </Select.Option>
                        <Select.Option key="3" value="Applied_ASC">
                          Applied Date Ascending
                        </Select.Option>
                        <Select.Option key="4" value="Applied_DESC">
                          Applied Date Descending
                        </Select.Option>
                        <Select.Option key="5" value="Last_ASC">
                          Last Updated Ascending
                        </Select.Option>
                        <Select.Option key="6" value="Last_DESC">
                          Last Updated Descending
                        </Select.Option>
                      </Select>
                    </Col>
                  </Row>
                </Button>

                <Button
                  type="primary"
                  className={commonCssStyle.dataImportBtnCandidaterecruit}
                  style={{ marginLeft: 0 }}
                  onClick={handleExportClick}
                  loading={exportLoading}
                >
                  <Row style={{ gap: "8px", alignItems: "center" }}>
                    <Col>
                      <Filedownload color={"white"} />
                    </Col>
                    <Col>
                      <p
                        className={`${commonCssStyle.filterAndSortTextStyle} ${commonCssStyle.marginBottomRemove}`}
                      >
                        Export to Excel
                      </p>
                    </Col>
                  </Row>
                </Button>

                <Button
                  type="primary"
                  className={commonCssStyle.dataImportBtnCandidaterecruit}
                  style={{ marginLeft: 0 }}
                  disabled={!selectedRowKeys || selectedRowKeys.length === 0}
                  onClick={openShareModal}
                >
                  <Row style={{ gap: "8px", alignItems: "center" }}>
                    <Col>
                      <NotifyClientIcon color={"white"} />
                    </Col>
                    <Col>
                      <p
                        className={`${commonCssStyle.filterAndSortTextStyle} ${commonCssStyle.marginBottomRemove}`}
                      >
                        Share with Client
                      </p>
                    </Col>
                  </Row>
                </Button>
              </div>
            </Col>
          </Row>

          <Row>
            <Col xs={24}>
              <Table
                scroll={{ x: "auto" }}
                pagination={{
                  size: "small",
                  current:
                    props.import_candidates_Filter_Data &&
                    props.import_candidates_Filter_Data.current_page
                      ? props.import_candidates_Filter_Data.current_page
                      : 1,
                  pageSize:
                    props.import_candidates_Filter_Data &&
                    props.import_candidates_Filter_Data.per_page,
                  total:
                    props.import_candidates_Filter_Data &&
                    props.import_candidates_Filter_Data.total,
                  showSizeChanger: false,
                  onChange: (props) => {
                    fetchRecords(props);
                  },
                }}
                rowKey="key"
                columns={columns}
                dataSource={
                  props.import_candidates_Filter_Data &&
                  props.import_candidates_Filter_Data.data &&
                  props.import_candidates_Filter_Data.data
                }
              />
            </Col>
          </Row>
        </Col>
      </Row>

      <Modal
        title={
          <p className={commonCssStyle.popUpHeadingText}>Unlink Candidate</p>
        }
        footer={
          <>
            <Row style={{ gap: "10px" }} justify="end" align="middle">
              <Col>
                <Button
                  type="default"
                  style={{ height: "48px", fontSize: "16px", width: "151px" }}
                  onClick={() => {
                    closeDeleteHandler();
                  }}
                  className={commonCssStyle.buttonSettingsSecondary}
                >
                  Cancel
                </Button>
              </Col>
              <Col>
                <Button
                  style={{ height: "48px", fontSize: "16px", width: "151px" }}
                  type="primary"
                  className={commonCssStyle.buttonSettingsPrimary}
                  onClick={() => {
                    confirmDeleteHandler();
                  }}
                >
                  Unlink
                </Button>
              </Col>
            </Row>
          </>
        }
        open={openDeleteModal}
        onCancel={closeDeleteHandler}
        onOk={confirmDeleteHandler}
      >
        <Row>
          <Col>
            <p className={commonCssStyle.tableHeadingTextData}>
              Are you sure you want to Unlink Candidate
            </p>
          </Col>
        </Row>
      </Modal>

      <Modal
        title={
          <p className={commonCssStyle.popUpHeadingText}>Share with Client</p>
        }
        open={shareModalOpen}
        onCancel={closeShareModal}
        footer={
          <Row style={{ gap: "10px" }} justify="end" align="middle">
            <Col>
              <Button
                type="default"
                style={{ height: "48px", fontSize: "16px", width: "151px" }}
                onClick={closeShareModal}
                className={commonCssStyle.buttonSettingsSecondary}
                disabled={shareSubmitting}
              >
                Cancel
              </Button>
            </Col>
            <Col>
              <Button
                style={{ height: "48px", fontSize: "16px", width: "151px" }}
                type="primary"
                className={commonCssStyle.buttonSettingsPrimary}
                onClick={submitShareToClient}
                loading={shareSubmitting}
                disabled={!shareFormValid}
              >
                Share
              </Button>
            </Col>
          </Row>
        }
      >
        <Form
          form={shareForm}
          layout="vertical"
          onFieldsChange={() => {
            const value = shareForm.getFieldValue("clientId")?.trim();
            const hasErrors = shareForm
              .getFieldsError()
              .some((field) => field.errors && field.errors.length > 0);
            setShareFormValid(Boolean(value) && !hasErrors);
          }}
        >
          <Form.Item
            label="Client Email"
            name="clientId"
            rules={[
              { required: true, message: "Client email is required" },
              { type: "email", message: "Please enter a valid email address" },
            ]}
          >
            <Input placeholder="Enter client email" />
          </Form.Item>

          <Form.Item label="Message" name="message">
            <Input.TextArea
              placeholder="Enter message to include in email"
              autoSize={{ minRows: 4, maxRows: 8 }}
            />
          </Form.Item>
          <p className={commonCssStyle.tableHeadingTextData}>
            Selected candidates: {selectedRowKeys.length} (max{" "}
            {MAX_SHARE_WITH_CLIENT_SELECTION})
          </p>
        </Form>
      </Modal>
      <RecruitmentCandidateFilter
        openFilter={opeRecruitmentCandidateFilter}
        onCloseFilter={CloseFilterHandler}
        employees={props.employees}
        clients={props.clients}
        requirements={props.requirements}
        tagsData={props.tagsData}
        recruitmentFilterHandler={recruitmentFilterHandler}
        candidates={props.candidates}
        TagsData={props.TagsData}
        get_all_status={props.get_all_status}
      />

      <ColumnSelectorModal
        isOpen={columnSelectorOpen}
        onClose={() => setColumnSelectorOpen(false)}
        onApply={handleExportWithColumns}
        availableColumns={availableColumnsForExport}
        loading={exportLoading}
      />

      <ScheduleInterviewDrawer
        onCandidateName={candidateId} //candidate id
        onInterviewName={interviewName} //specifing from schedule drawer from which page the data is comming like example recruitment, it's noting but modal name
        onOpenSchedileInterview={scheduleDrawer} // used to open the drawer
        onCloseSchedileInterview={closeDrawerHandler} // used to close the drawer
      />
      <PermissionMessage
        onOpenPMModal={openPMModal}
        onClosePMModal={() => {
          setOpenPMModal({ open: false, permission: "" });
        }}
      />
    </>
  );
}

const mapStateToProps = (state) => {
  return {
    // candidates: state.candidates.candidates,
    // candidatesFilterData: state.candidates.candidatesFilter,
    import_candidates_Filter_Data:
      state.recruitment.import_candidates_Filter_Data,
    clients: state.client.clients,
    tagsData: state.tags.tags,
    requirements: state.requirements.requirements,
    employees: state.employee.employees,
    candidates: state.candidates.candidates,
    TagsData: state.tags.tags,
    get_all_status: state.recruitment.get_all_status,
    permissions: state.authpermissions.permissions,
  };
};
const mapDispatchToProps = (dispatch) => {
  return {
    getCandidatesFilterAllDataHandler: (id) => {
      dispatch(getRecruitmentsAllCandidatesFilterAction(id));
    },
    getClientsHandler: () => {
      dispatch(getClientsAction());
    },
    getTagHandler: () => {
      dispatch(getTagsAction());
    },
    getRequirementAction: () => {
      dispatch(getRequirementsAction());
    },
    getEmployeesAction: () => {
      dispatch(getEmployeesAction());
    },
    getCandidateDetailsHandler: () => {
      dispatch(getCandidatesAction());
    },
    getTagHandler: () => {
      dispatch(getTagsAction());
    },
    getRecruitmentAllStatusHandler: () => {
      dispatch(getRecruitmentAllStatusAction());
    },
    deleteCandidateFromPool: (id, callback) => {
      dispatch(deleteCandidatesFroPoolAction(id, callback));
    },
    getCheckPermissionHandler: (id, callback) => {
      dispatch(checkPermissionAction(id, callback));
    },
    exportExternalCandidateDetails: (val, callback) => {
      dispatch(exportRecruitmentDetaisAction(val));
    },
    shareRecruitmentCandidatesResumesToClient: (val, callback) => {
      dispatch(shareRecruitmentCandidatesResumesToClientAction(val, callback));
    },
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(RecruitmentCandidates);
